import React, { Component } from "react";
import Async from "components/Async";
import api from "services/api";
import User from "./User";
import Page from "../../components/Page";

const Listing = ({ users, onDelete, loadDetails }) => {
  return (
    <div>
      {users.map(u => (
        <User
          {...u}
          key={u.id}
          onDelete={() => onDelete(u.id)}
          loadDetails={() => loadDetails({ user_id: u.id })}
        />
      ))}
    </div>
  );
};

class DeleteList extends Component {
  state = {};

  onDelete = async user_id => {
    await api.delete_list.admin_delete({ user_id });
    this.listing.refresh();
  };


  render() {
    return (
      <Page title="Delete List">
        <Async
          fetchProps={api.delete_list.user.list}
          ref={a => (this.listing = a)}
        >
          {users => (
            <Listing
              users={users}
              onDelete={this.onDelete}
            />
          )}
        </Async>
      </Page>
    );
  }
}

export default DeleteList;
